import React from 'react';
import { ShieldCheck, Users, Banknote, Lock, FileSearch } from 'lucide-react';
import { Button } from './ui/Button';
export function TrustSecurity() {
  const features = [{
    icon: <Users className="w-6 h-6" data-id="element-474" />,
    title: 'Brokers, Not Lenders',
    desc: 'We work for you, not the banks.'
  }, {
    icon: <Banknote className="w-6 h-6" data-id="element-475" />,
    title: 'No Upfront Fees',
    desc: 'We only get paid when you get funded.'
  }, {
    icon: <ShieldCheck className="w-6 h-6" data-id="element-476" />,
    title: 'Verified Lenders',
    desc: 'Every lender in our network is vetted.'
  }, {
    icon: <Lock className="w-6 h-6" data-id="element-477" />,
    title: 'Secure Application',
    desc: 'Bank-level 256-bit encryption.'
  }, {
    icon: <FileSearch className="w-6 h-6" data-id="element-478" />,
    title: 'Transparent Process',
    desc: 'No hidden terms or surprises.'
  }];
  return <section className="py-20 bg-white border-y border-gray-100" data-id="element-479">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-480">
        <div className="text-center mb-12" data-id="element-481">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-482">
            Your Trusted Business Funding Partner
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 mb-12" data-id="element-483">
          {features.map((feature, index) => <div key={index} className="flex flex-col items-center text-center" data-id="element-484">
              <div className="w-12 h-12 rounded-full bg-green-50 flex items-center justify-center text-[#00E676] mb-4" data-id="element-485">
                {feature.icon}
              </div>
              <h3 className="font-bold text-gray-900 mb-1" data-id="element-486">{feature.title}</h3>
              <p className="text-sm text-gray-500" data-id="element-487">{feature.desc}</p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-488">
          <Button variant="outline" onClick={() => document.getElementById('contact')?.scrollIntoView()} data-id="element-489">
            Check Rates (No Risk)
          </Button>
        </div>
      </div>
    </section>;
}